import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CookieConsent.css';

const STORAGE_KEY = 'lms_cookie_consent';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const acceptRef = useRef(null);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (visible && acceptRef.current) {
      acceptRef.current.focus();
    }
  }, [visible]);

  const accept = (analytics) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ analytics, timestamp: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label={t('gdpr.cookieTitle')}
      className="cookie-banner"
    >
      <div className="cookie-content">
        <p>
          <strong>{t('gdpr.cookieTitle')}.</strong>{' '}
          {t('gdpr.cookieDesc')}{' '}
          <Link to="/privacy">{t('gdpr.learnMore')}</Link>.
        </p>
        <div className="cookie-actions">
          <button
            ref={acceptRef}
            className="btn-primary cookie-btn"
            onClick={() => accept(true)}
          >
            {t('gdpr.acceptAll')}
          </button>
          <button
            className="btn-secondary cookie-btn"
            onClick={() => accept(false)}
          >
            {t('gdpr.rejectOptional')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
